<template>
  <div class="ima-help">
    <h1 class="title">Hilfe</h1>
    <div>Hier finden Sie die aktuelle <a href="https://data.ima-international.com/s/6dQuN1WPC1XYLx7" target="_blank">Dokumentation</a>.</div>

  </div>
</template>

<script>
import routes from '@/mixins/routes'

export default {
  name: 'ima-help',
  mixins: [routes],
  data () {
    return {}
  }
}
</script>

<style lang="scss">

</style>




// WEBPACK FOOTER //
// src/components/Help.vue